import { render, staticRenderFns } from "./listed_single_coin.vue?vue&type=template&id=78606854&"
import script from "./listed_single_coin.vue?vue&type=script&lang=js&"
export * from "./listed_single_coin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports